/**
 * Logger interface defines the standard logging methods.
 */
export interface Logger {
  /**
   * Logs an informational message.
   * @param msg the message to log
   * @param rest additional data to log
   */
  log: (msg: string, ...rest: unknown[]) => void;
  /**
   * Logs a debug message.
   * @param msg the message to log
   * @param rest additional data to log
   */
  debug: (msg: string, ...rest: unknown[]) => void;
  /**
   * Logs a warning message.
   * @param msg the message to log
   * @param rest additional data to log
   */
  warn: (msg: string, ...rest: unknown[]) => void;
  /**
   * Logs an error message.
   * @param msg the message to log
   * @param rest additional data to log
   */
  error: (msg: string, ...rest: unknown[]) => void;
}

export const LOG_LEVELS = {
  DANGER: 0,
  WARNING: 1,
  INFO: 2,
  SUCCESS: 3,
  DEBUG: 4,
} as const;
export type LogMode = keyof typeof LOG_LEVELS;

export type LogLevels = (typeof LOG_LEVELS)[LogMode];
